var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{ref:"grid",staticClass:"fill-height",staticStyle:{"opacity":"0.5"},style:(_vm.layoutStyle),attrs:{"color":_vm.element.active ? _vm.wsBACKGROUND : 'transparent'}})}
var staticRenderFns = []

export { render, staticRenderFns }